import _extends from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _objectWithoutProperties from "/ecomm-marketplace/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["width", "bg", "right", "display", "fontSize", "carrotTop", "className", "mt", "pr"];
var __jsx = React.createElement;
import React, { forwardRef } from 'react';
import { space, height, color, top, width as styledWidth, right as styledRight, display as styledDisplay, fontSize as styledFontSize, borderRadius } from 'styled-system';
import styled from 'styled-components';
import { mediaQueries } from 'shared/styles';
export var SelectContainer = styled.span.withConfig({
  displayName: "select__SelectContainer",
  componentId: "sc-md8oj2-0"
})(["", " ", " ", " ", " position:relative;cursor:pointer;&:after{border:1px solid #46494c;border-left:4px solid transparent !important;border-right:4px solid transparent !important;border-top:5px solid #797e83 !important;border-bottom:none !important;transform:none !important;content:' ';display:block;pointer-events:none;position:absolute;transform:rotate(-45deg);z-index:1;top:47%;", " ", "}&.--overflow{&:before{content:'...';position:absolute;top:29%;right:26px;width:22px;z-index:2;background-color:white;}}"], styledWidth, color, styledDisplay, space, styledRight, top);
export var StyledSelect = styled.select.withConfig({
  displayName: "select__StyledSelect",
  componentId: "sc-md8oj2-1"
})(["align-items:center;appearance:none;background-color:", ";border:", ";border-color:", ";border-radius:", ";box-shadow:none;color:#6d747b;cursor:", ";display:block;font-size:13px;height:45px;min-width:50px;outline:none;padding:2px 31px 0px 12px;position:relative;width:100%;", " ", " ", " ", " &:active,&:focus{border:", ";box-shadow:none;}&:hover{border:", ";}&[disabled]{background-color:#ecf0f3;color:#7a7a7a;border-color:whitesmoke;opacity:unset;}&:-moz-focusring{color:transparent;text-shadow:0 0 0 #6d747b;}option:not(:checked){color:#707478;}@media ", "{font-size:14px;}"], function (props) {
  return props.backgroundColor || 'transparent';
}, function (props) {
  return props.border || '1px solid transparent';
}, function (props) {
  return props.error ? '#e25241 !important' : '#d1d5da';
}, function (_ref) {
  var _theme$customized$rad, _theme$customized;
  var theme = _ref.theme;
  return (_theme$customized$rad = theme === null || theme === void 0 || (_theme$customized = theme.customized) === null || _theme$customized === void 0 || (_theme$customized = _theme$customized.radius) === null || _theme$customized === void 0 ? void 0 : _theme$customized.sm) !== null && _theme$customized$rad !== void 0 ? _theme$customized$rad : '3px';
}, function (props) {
  return props.disabled ? 'not-allowed' : 'pointer';
}, space, height, styledFontSize, borderRadius, function (props) {
  return props.border || '1px solid #dbdbdb';
}, function (props) {
  return props.border || '1px solid #b6b6b6';
}, mediaQueries.largePhone);
var Select = /*#__PURE__*/forwardRef(function (/** @type { any } */_ref2, ref) {
  var width = _ref2.width,
    _ref2$bg = _ref2.bg,
    bg = _ref2$bg === void 0 ? '#fcfdfe' : _ref2$bg,
    _ref2$right = _ref2.right,
    right = _ref2$right === void 0 ? '18px' : _ref2$right,
    _ref2$display = _ref2.display,
    display = _ref2$display === void 0 ? ['block'] : _ref2$display,
    _ref2$fontSize = _ref2.fontSize,
    fontSize = _ref2$fontSize === void 0 ? ['16px', '16px', '16px', '13px'] : _ref2$fontSize,
    carrotTop = _ref2.carrotTop,
    className = _ref2.className,
    mt = _ref2.mt,
    pr = _ref2.pr,
    props = _objectWithoutProperties(_ref2, _excluded);
  return __jsx(SelectContainer, {
    bg: bg,
    className: className,
    display: display,
    mt: mt,
    right: right,
    top: carrotTop,
    width: width,
    pr: pr
  }, __jsx(StyledSelect, _extends({
    ref: ref,
    fontSize: fontSize
  }, props)));
});
export default Select;